<!-- views/ProductManagement.vue -->
<template>
  <div class="product-management">
    <Sidebar />
    <div class="main-content">
      <!-- 头部 -->
      <div class="header">
        <div class="navigation">
          <span class="nav-item">首页</span> /
          <span class="nav-item">产品列表</span> /
          <span class="nav-item">产品修改</span>
        </div>
        <div class="actions">
          <div class="user-avatar">P</div>
        </div>
      </div>

      <!-- 首页产品区域 -->
      <div class="section">
        <h3 class="section-title">首页产品</h3>
        <div class="product-grid">
          <div class="product-categories">
            <div class="category-header main-products">中间体</div>
            <div class="category-header middle-products">精细化学品</div>
            <div class="category-header other-products">其他</div>
          </div>

          <div class="product-column">
            <draggable
              v-model="indexPageProducts.intermediates"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn active"
                      @click="removeFromFavorites(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <!-- <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button class="delete-btn" @click="deleteProduct(element, 'favorite')">
                      <i class="fas fa-times"></i>
                    </button> -->
                  </div>
                </div>
              </template>
            </draggable>
          </div>

          <div class="product-column">
            <draggable
              v-model="indexPageProducts.fineChemical"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn active"
                      @click="removeFromFavorites(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <!-- <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button class="delete-btn" @click="deleteProduct(element, 'favorite')">
                      <i class="fas fa-times"></i>
                    </button> -->
                  </div>
                </div>
              </template>
            </draggable>
          </div>

          <div class="product-column">
            <draggable
              v-model="indexPageProducts.otherProducts"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn active"
                      @click="removeFromFavorites(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <!-- <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button class="delete-btn" @click="deleteProduct(element, 'favorite')">
                      <i class="fas fa-times"></i>
                    </button> -->
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
      </div>

      <!-- 所有产品区域 -->
      <div class="section">
        <h3 class="section-title">所有产品</h3>
        <div class="product-grid">
          <div class="product-categories">
            <div class="category-header main-products">
              中间体
              <button
                class="add-btn category-add-btn"
                @click="openAddModal('INTERMEDIATES')"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
            <div class="category-header middle-products">
              精细化学品
              <button
                class="add-btn category-add-btn"
                @click="openAddModal('FINE_CHEMICAL')"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
            <div class="category-header other-products">
              其他
              <button
                class="add-btn category-add-btn"
                @click="openAddModal('OTHERS')"
              >
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>

          <div class="product-column">
            <draggable
              v-model="allProducts.intermediates"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
              @end="handleDragEnd('intermediates')"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn"
                      :class="{ active: isInFavorites(element) }"
                      @click="toggleFavorite(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button
                      class="delete-btn"
                      @click="deleteProductA(element, 'all')"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </template>
            </draggable>
          </div>

          <div class="product-column">
            <draggable
              v-model="allProducts.fineChemical"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
              @end="handleDragEnd('fineChemical')"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn"
                      :class="{ active: isInFavorites(element) }"
                      @click="toggleFavorite(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button
                      class="delete-btn"
                      @click="deleteProductA(element, 'all')"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </template>
            </draggable>
          </div>

          <div class="product-column">
            <draggable
              v-model="allProducts.otherProducts"
              group="products"
              item-key="productId"
              :animation="200"
              class="draggable-container"
              @end="handleDragEnd('otherProducts')"
            >
              <template #item="{ element }">
                <div class="product-item">
                  <span>{{ element.productName }}</span>
                  <div class="button-group">
                    <button
                      class="star-btn"
                      :class="{ active: isInFavorites(element) }"
                      @click="toggleFavorite(element)"
                    >
                      <i class="fas fa-star"></i>
                    </button>
                    <button class="edit-btn" @click="openEditModal(element)">
                      <i class="fas fa-cog"></i>
                    </button>
                    <button
                      class="delete-btn"
                      @click="deleteProductA(element, 'all')"
                    >
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </template>
            </draggable>
          </div>
        </div>
      </div>

      <!-- 产品表单弹窗 -->
      <product-form-modal
        v-if="showModal"
        :mode="modalMode"
        :product="currentProduct"
        :category="currentCategory"
        @save="handleSave"
        @request-close="closeModal"
      />
    </div>
  </div>
</template>

<script>
// ProductManagement.vue <script> 部分的优化示例

import { defineComponent, reactive, ref, watch, computed } from "vue"; // 引入 computed
import draggable from "vuedraggable";
import ProductFormModal from "../components/ProductFormModal.vue";
import Sidebar from "../components/Sidebar.vue";
import { ElMessage } from 'element-plus';
import {
  getAllProducts,
  addProduct,
  editProduct,
  deleteProduct,
  offIndex,
  onIndex,
  changeProductSort,
} from "@/api";

// --- 常量定义 ---
const CATEGORY_MAP = {
  INTERMEDIATES: "intermediates",
  FINE_CHEMICAL: "fineChemical",
  OTHERS: "otherProducts",
};
const PRODUCT_TYPES = Object.keys(CATEGORY_MAP); // ['INTERMEDIATES', 'FINE_CHEMICAL', 'OTHERS']

export default defineComponent({
  name: "ProductManagement",
  components: {
    draggable,
    ProductFormModal,
    Sidebar,
  },
  setup() {
    // --- 状态定义 ---
    // 考虑使用单一数据源 + 计算属性 (可选方案)
    // const allProductsRaw = ref([]); // 存储从 API 获取的原始产品列表

    // 当前方案：保持两个 reactive 对象
    const allProducts = reactive({ intermediates: [], fineChemical: [], otherProducts: [] });
    const indexPageProducts = reactive({ intermediates: [], fineChemical: [], otherProducts: [] });

    const showModal = ref(false);
    const modalMode = ref("add");
    const currentProduct = ref(null);
    const currentCategory = ref("");

    // --- 计算属性 (如果采用单一数据源方案) ---
    /*
    const categorizedProducts = computed(() => {
      const result = { all: {}, index: {} };
      PRODUCT_TYPES.forEach(type => {
        const key = CATEGORY_MAP[type];
        result.all[key] = allProductsRaw.value.filter(p => p.productType === type).sort((a, b) => a.productSort - b.productSort);
        result.index[key] = result.all[key].filter(p => p.productIndexTag > 0); // 假设 index tag > 0 表示首页
      });
      return result;
    });
    // 然后模板中用 categorizedProducts.all.intermediates 等访问
    // 拖拽和首页逻辑需要调整
    */

    // --- 辅助函数 ---
    /** 根据产品类型获取对应的首页列表 */
    const getFavoriteList = (productType) => {
      const key = CATEGORY_MAP[productType];
      return key ? indexPageProducts[key] : undefined;
    };

    /** 从指定列表对象中查找并移除产品 */
    const findAndRemoveProduct = (listObject, product) => {
      const key = CATEGORY_MAP[product.productType];
      if (key && listObject[key]) {
        const index = listObject[key].findIndex(p => p.productId === product.productId);
        if (index !== -1) {
          listObject[key].splice(index, 1);
          return true; // 表示成功移除
        }
      }
      return false; // 未找到或列表不存在
    };

    /** 对产品列表进行分类和排序 */
    const categorizeAndSortProducts = (products) => {
        // 清空现有列表
        Object.keys(allProducts).forEach(key => allProducts[key] = []);
        Object.keys(indexPageProducts).forEach(key => indexPageProducts[key] = []);

        products.forEach((product) => {
            const categoryKey = CATEGORY_MAP[product.productType];
            if (categoryKey) {
                allProducts[categoryKey].push(product);
                if (product.productIndexTag > 0) { // 假设 tag > 0 为首页
                    indexPageProducts[categoryKey].push(product);
                }
            }
        });

        // 排序
        Object.keys(allProducts).forEach(key => {
            allProducts[key].sort((a, b) => a.productSort - b.productSort);
        });
        Object.keys(indexPageProducts).forEach(key => {
            indexPageProducts[key].sort((a, b) => a.productSort - b.productSort);
        });
    };


    // --- API 调用与业务逻辑 ---
    const fetchProducts = async () => {
      try {
        const response = await getAllProducts();
        // 假设 response.data 是产品数组
        if (response && response.data && Array.isArray(response.data)) {
           categorizeAndSortProducts(response.data);
        } else {
            console.warn("getAllProducts 返回的数据格式不符合预期", response);
            categorizeAndSortProducts([]); // 清空列表
        }
      } catch (error) {
        console.error("获取产品数据错误:", error);
        // ElMessage 已经在拦截器中处理，这里可以不再提示
      }
    };

    fetchProducts(); // 初始化加载

    const isInFavorites = (product) => {
      const favList = getFavoriteList(product.productType);
      return favList?.some(p => p.productId === product.productId) || false;
    };

    const addToFavorites = async (product) => {
        const favList = getFavoriteList(product.productType);
        if (favList && !isInFavorites(product)) {
            try {
                await onIndex({ productId: product.productId }); // 先调用 API
                // API 成功后再更新本地状态 (或者直接重新 fetch)
                favList.push({ ...product, productIndexTag: 1 }); // 更新 tag 状态
                favList.sort((a, b) => a.productSort - b.productSort); // 保持排序
                // 更新 allProducts 中对应项的 tag (如果需要实时同步)
                const allList = allProducts[CATEGORY_MAP[product.productType]];
                const indexInAll = allList.findIndex(p => p.productId === product.productId);
                if (indexInAll !== -1) {
                    allList[indexInAll].productIndexTag = 1;
                }
                 ElMessage.success("添加首页成功");
            } catch (error) {
                 console.error("添加首页失败:", error);
                 // ElMessage 应该在拦截器或 API 函数内部处理了
            }
        }
    };

    const removeFromFavorites = async (product) => {
        const favList = getFavoriteList(product.productType);
        if (favList && isInFavorites(product)) {
             try {
                await offIndex({ productId: product.productId }); // 先调用 API
                // API 成功后再更新本地状态
                const index = favList.findIndex(p => p.productId === product.productId);
                if (index !== -1) {
                    favList.splice(index, 1);
                }
                 // 更新 allProducts 中对应项的 tag
                 const allList = allProducts[CATEGORY_MAP[product.productType]];
                 const indexInAll = allList.findIndex(p => p.productId === product.productId);
                 if (indexInAll !== -1) {
                     allList[indexInAll].productIndexTag = 0; // 或后端定义的非首页值
                 }
                 ElMessage.success("取消首页成功");
             } catch (error) {
                 console.error("取消首页失败:", error);
             }
        }
    };

    const toggleFavorite = (product) => {
      if (isInFavorites(product)) {
        removeFromFavorites(product);
      } else {
        addToFavorites(product);
      }
    };

    const deleteProductA = async (product) => { // listType 参数似乎不再需要
      try {
        // 可以添加一个确认弹窗
        // await ElMessageBox.confirm(`确定要删除产品 "${product.productName}" 吗?`, '提示', { type: 'warning' });

        await deleteProduct(product.productId); // 调用 API

        // API 成功后更新本地状态
        findAndRemoveProduct(allProducts, product);
        findAndRemoveProduct(indexPageProducts, product); // 同时从首页列表移除

        ElMessage.success("删除产品成功");
      } catch (error) {
         if (error !== 'cancel') { // 排除 ElMessageBox 的取消操作
             console.error("删除产品失败:", error);
             // ElMessage 应该在拦截器或 API 函数内部处理了
         }
      }
    };

    // --- 弹窗控制 ---
    const openAddModal = (category) => {
      modalMode.value = "add";
      currentProduct.value = null;
      currentCategory.value = category;
      showModal.value = true;
    };
    const openEditModal = (product) => {
      modalMode.value = "edit";
      // 传入 product 的副本，防止模态框内修改直接影响列表
      currentProduct.value = JSON.parse(JSON.stringify(product));
      currentCategory.value = product.productType;
      showModal.value = true;
    };
    const closeModal = () => {
      // console.log("关闭弹窗"); // 已移动到 watch 中
      showModal.value = false;
      // 重置 currentProduct 和 currentCategory 可能导致 watch 触发，
      // 但如果 modal 是 v-if 控制的，关闭时组件已销毁，影响不大
      // currentProduct.value = null;
      // currentCategory.value = "";
    };

    // --- Watcher & 保存/拖拽处理 ---
    watch(showModal, (newValue, oldValue) => {
      // console.log(`ProductManagement: showModal changed from ${oldValue} to ${newValue}`);
      if (newValue === false && oldValue === true) {
        // console.trace("Stack trace for showModal becoming false:");
        // 模态框关闭后，重置临时状态
        currentProduct.value = null;
        currentCategory.value = "";
      }
    });

    const handleSave = async (productDataFromModal) => {
      try {
        if (modalMode.value === "add") {
          await addProduct({
            productType: productDataFromModal.productType,
            productName: productDataFromModal.productName,
            productSynonyms: productDataFromModal.productSynonyms,
            productCas: productDataFromModal.productCas,
            productStrucPic: productDataFromModal.productStrucPic,
            productAddX2List: productDataFromModal.productAddX2List || [],
          });
          ElMessage.success("产品新增成功");
        } else {
          await editProduct({
            productId: productDataFromModal.id,
            productType: productDataFromModal.productType,
            productName: productDataFromModal.productName,
            productSynonyms: productDataFromModal.productSynonyms,
            productCas: productDataFromModal.productCas,
            productStrucPic: productDataFromModal.productStrucPic,
            productAddX2List: productDataFromModal.productAddX2List || [],
          });
           ElMessage.success("产品编辑成功");
        }
        closeModal(); // 保存成功后关闭
        await fetchProducts(); // 刷新列表
      } catch (error) {
        console.error("保存产品失败:", error);
        // ElMessage 在拦截器或 API 函数中处理
      }
    };

    const handleDragEnd = async (event) => {
        // 注意：vuedraggable 的 @end 事件可能不足以获取完整的排序信息
        // 可能需要在 @change 或监听 v-model 的变化来获取排序后的完整列表
        // 这里假设拖拽后 allProducts 的顺序已经是最新的
      try {
        // 优化：直接使用当前的 allProducts 状态构建排序数据
        allProducts.intermediates.forEach((product, index) => {
          product.productType = 'INTERMEDIATES'; // 更新排序号
        });

        allProducts.fineChemical.forEach((product, index) => {
          product.productType = 'FINE_CHEMICAL'; // 更新排序号
        });

        allProducts.otherProducts.forEach((product, index) => {
          product.productType = 'OTHERS'; // 更新排序号
        });

        const sortData = [
          ...allProducts.intermediates,
          ...allProducts.fineChemical,
          ...allProducts.otherProducts,
        ].map((product, index) => ({ // 可以只发送 ID 和新的 sort 值，或按后端要求
          productId: product.productId,
          productType: product.productType,
          // productSort: index + 1 // 如果后端需要排序号
        }));

        if (sortData.length === 0) return; // 没有产品可排序

        // 过滤掉可能不存在的 productId (如果数据同步有延迟)
        const validSortData = sortData.filter(item => item.productId);

        if (validSortData.length > 0) {
             await changeProductSort(validSortData); // API 需要接收数组
             // 可选：如果 API 不返回新列表，本地乐观更新排序或重新 fetch
             // await fetchProducts(); // 保留 fetch 作为简单可靠的方式
             ElMessage.success("排序更新成功");
        }

      } catch (error) {
        console.error("更新排序失败:", error);
         ElMessage.error(`更新排序失败: ${error.message || '请重试'}`);
         // 排序失败时，可能需要重新 fetch 来恢复到之前的顺序
         await fetchProducts();
      }
    };

    return {
      allProducts,
      indexPageProducts,
      // categorizedProducts, // 如果使用计算属性方案
      isInFavorites,
      toggleFavorite,
      removeFromFavorites, // 直接在模板中使用 toggleFavorite 可能更简洁
      deleteProductA,
      openAddModal,
      openEditModal,
      showModal,
      modalMode,
      currentProduct,
      currentCategory,
      handleSave,
      closeModal,
      handleDragEnd,
    };
  },
});
</script>

<style scoped>
.product-management {
  font-family: "Segoe UI", Arial, sans-serif;
  display: flex;
  min-height: 100vh;
}

.main-content {
  margin-left: 200px;
  flex: 1;
  padding: 30px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 15px 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.navigation {
  display: flex;
  gap: 8px;
  font-size: 16px;
}

.nav-item {
  cursor: pointer;
  color: #555;
  transition: color 0.3s ease;
}

.nav-item:hover {
  color: #5a9bd4;
  text-decoration: underline;
}

.actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: linear-gradient(45deg, #5a9bd4, #a3c5e8);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(90, 155, 212, 0.3);
  transition: transform 0.3s ease;
}

.user-avatar:hover {
  transform: scale(1.1);
}

.section {
  margin-bottom: 40px;
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.section:hover {
  transform: translateY(-5px);
}

.section-title {
  margin: 0 0 20px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  background: linear-gradient(90deg, #e9ecef 0%, #f5f7fa 100%);
  padding: 10px;
  border-radius: 8px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.product-categories {
  grid-column: 1 / -1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.category-header {
  position: relative;
  color: white;
  padding: 12px 20px;
  text-align: center;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.category-header:hover {
  transform: translateY(-3px);
}

.main-products {
  background: linear-gradient(45deg, #6bb788, #8ed1a4);
}

.middle-products {
  background: linear-gradient(45deg, #5a9bd4, #a3c5e8);
}

.other-products {
  background: linear-gradient(45deg, #9575cd, #b39ddb);
}

.category-add-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 16px;
  padding: 6px;
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
}

.category-add-btn:hover {
  background: rgba(255, 255, 255, 0.4);
  transform: translateY(-50%) scale(1.2);
}

.product-column {
  min-height: 30px;
}

.draggable-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 30px;
}

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #e8ecef;
  cursor: move;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.product-item:hover {
  background: #f1f5f9;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.button-group {
  display: flex;
  gap: 8px;
}

.star-btn,
.edit-btn,
.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.star-btn {
  color: #d4d4d4;
}

.star-btn.active {
  color: #ffd700;
  background: rgba(255, 215, 0, 0.1);
}

.star-btn:hover {
  background: rgba(255, 215, 0, 0.2);
}

.edit-btn {
  color: #6c757d;
}

.edit-btn:hover {
  color: #5a9bd4;
  background: rgba(90, 155, 212, 0.1);
}

.delete-btn {
  color: #e57373;
}

.delete-btn:hover {
  color: #ef5350;
  background: rgba(229, 115, 115, 0.1);
}
</style>
